import React from 'react'
import styled from '@emotion/styled'
import { AccountHeader } from '@mobi/component-library/Account'
import { Button, InfoBox } from '@mobi/component-library/Common/V2'
import { FormLayout } from '@mobi/component-library/Verification/Common/Layouts'
import { gapY } from '@mobi/component-library/Utils/gap'
import { spacing } from '@mobi/component-library/Theme/Common'
import { useHistory } from '@mobi/account/Hooks'
import { callCenterPhoneNumber } from '@mobi/utils/phone'

export const FailedVerificationGeneral = () => {
  const history = useHistory()
  //TODO: use real reference number
  const referenceNumber = 123456

  return (
    <FormLayout>
      <AccountHeader
        alignItems='start'
        title='We were unable to verify your identity.'
        description={
          <span>
            Unfortunately we couldn't verify your identify with the details you provided, please
            contact us on <b>1300 36 36 88</b> or use the button below.
          </span>
        }
        style={{ marginBottom: '0rem' }}
      />
      <InfoBox color='blue' size='sm'>
        <div>
          Please use reference <b>#{referenceNumber}</b> and have a suitable ID at hand for the
          call.
        </div>
      </InfoBox>
      <Footer>
        <Button
          isFullWidth
          onClick={() => {
            history.push(callCenterPhoneNumber)
          }}
        >
          Call now
        </Button>
      </Footer>
    </FormLayout>
  )
}

const Footer = styled.footer(gapY(spacing.sm))
